document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.hero-slider .swiper', {
        loop: true, // Enable looping
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        autoplay: {
            delay: 5000, // Delay between slides in ms
            disableOnInteraction: false,
        },
        speed: 1000, // Transition speed in ms
    });
});
